import { publicUrl } from '@src/publicUrl';
import {
  SECRET_SANTA_FOR_CLASSROOM_PATH,
  SECRET_SANTA_FOR_COWORKERS_PATH,
  SECRET_SANTA_FOR_FAMILY_PATH,
  SECRET_SANTA_FOR_FRIENDS_PATH,
  WHITE_ELEPHANT_PATH,
} from '@src/routing/routes';

/** Homepage carousel and landing “related” cards — same five formats. */
export const EXCHANGE_CARDS = [
  {
    href: SECRET_SANTA_FOR_FRIENDS_PATH,
    image: publicUrl('home/friends.jpg'),
    icon: 'heart',
    tagKey: 'home.exchanges.friends.tag',
    titleKey: 'home.exchanges.friends.title',
  },
  {
    href: SECRET_SANTA_FOR_COWORKERS_PATH,
    image: publicUrl('home/coworkers.jpg'),
    icon: 'cup',
    tagKey: 'home.exchanges.coworkers.tag',
    titleKey: 'home.exchanges.coworkers.title',
  },
  {
    href: SECRET_SANTA_FOR_FAMILY_PATH,
    image: publicUrl('home/family.jpg'),
    icon: 'home',
    tagKey: 'home.exchanges.family.tag',
    titleKey: 'home.exchanges.family.title',
  },
  {
    href: SECRET_SANTA_FOR_CLASSROOM_PATH,
    image: publicUrl('home/classroom.jpg'),
    icon: 'edit',
    tagKey: 'home.exchanges.classroom.tag',
    titleKey: 'home.exchanges.classroom.title',
  },
  {
    href: WHITE_ELEPHANT_PATH,
    image: publicUrl('home/white-elephant.jpg'),
    icon: 'gift',
    tagKey: 'home.exchanges.party.tag',
    titleKey: 'home.exchanges.party.title',
  },
] as const;

export function exchangeImageFor(href: string): string | undefined {
  return EXCHANGE_CARDS.find((card) => card.href === href)?.image;
}
